//Randomly selects a pivot, swap that pivot value with the last element
export function getQuickSortRandomPivotAnimations(array) {
  const animations = [];
  let start = 0;
  let end = array.length - 1;
  quickSortRandomPivot(array, start, end, animations);
  return animations;
}

function quickSortRandomPivot(array, start, end, animations) {
  if (start >= end) {
    return;
  }
  let pivotIdx = partition(array, start, end, animations);
  quickSortRandomPivot(array, start, pivotIdx - 1, animations);
  quickSortRandomPivot(array, pivotIdx + 1, end, animations);
}

function partition(array, start, end, animations) {
  let randomPivotIdx = Math.floor(Math.random() * (end - start + 1)) + start;
  animations.push([randomPivotIdx, end]);
  animations.push([randomPivotIdx, end]);
  animations.push([randomPivotIdx, array[end]]);
  animations.push([end, array[randomPivotIdx]]);
  swap(array, randomPivotIdx, end);
  let pivotValue = array[end];
  let currentSmaller = start - 1;
  while (start < end) {
    animations.push([start, end]);
    animations.push([start, end]);
    if (array[start] <= pivotValue) {
      currentSmaller += 1;
      animations.push([start, array[currentSmaller]]);
      animations.push([currentSmaller, array[start]]);
      swap(array, currentSmaller, start);
    } else {
      animations.push([0, array[0]]);
      animations.push([0, array[0]]);
    }
    start += 1;
  }
  animations.push([end, currentSmaller + 1]);
  animations.push([end, currentSmaller + 1]);
  animations.push([end, array[currentSmaller + 1]]);
  animations.push([currentSmaller + 1, array[end]]);
  swap(array, currentSmaller + 1, end);
  return currentSmaller + 1;
}
const swap = function(array, i, j) {
  let temp = array[i];
  array[i] = array[j];
  array[j] = temp;
};
